module.exports = __webpack_public_path__ + "media/images/icons/all_meal-23fe1594a25b4b7043dca0c2bab595db.png";